
import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export const RefeedingCard: React.FC = () => {
  return (
    <Card className="w-full p-4 bg-green-50 border-green-300">
      <h3 className="text-lg font-semibold text-green-700 mb-2">Fast Complete!</h3>
      <p className="text-sm text-green-600 mb-3">
        Congratulations on completing your fast! For proper refeeding guidance:
      </p>
      <Button variant="outline" className="bg-green-500 text-white hover:bg-green-600 w-full" asChild>
        <Link to="/refeeding">View Refeeding Tips</Link>
      </Button>
    </Card>
  );
};
